import { useEffect, useState } from "react";

import { Alert, Snackbar, Button } from "@mui/material";
import { APP_VERSION } from "@/config";

export default function VersionChecker() {
    const [updateAvailable, setUpdateAvailable] = useState(false);
    const intervalTime = 5 * 60 * 1000; // 5 min

    useEffect(() => {
        const checkVersion = async () => {
            try {
                const response = await fetch(`/version.json?t=${Date.now()}`);
                if (!response.ok) {
                    return;
                }

                const data = await response.json();

                if (data.version && data.version !== APP_VERSION) {
                    setUpdateAvailable(true);
                }
            } catch (error) {
                console.error("Failed to check version:", error);
            }
        };

        checkVersion();

        const intervalId = setInterval(checkVersion, intervalTime);
        return () => clearInterval(intervalId);
    }, []);

    const handleRefresh = () => {
        window.location.reload(true);
    };

    return (
        <Snackbar
            open={updateAvailable}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
            <Alert
                severity="info"
                variant="filled"
                action={
                    <Button
                        color="inherit"
                        size="small"
                        onClick={handleRefresh}
                    >
                        CLICK TO REFRESH
                    </Button>
                }
            >
                A new version of MakeOS is available.
            </Alert>
        </Snackbar>
    );
}
